import React from "react";
import { Link } from "react-router-dom"; 
import "./styles.css"

const BlogCard = ({ blog }) => {
  return (
    <Link 
      className="card-link-wrapper" 
      to={`/blogs/${blog.slug}`} 
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      
        <div className="card">
        <div className="header-section">
          <span className="read-time">{blog.readTime}</span>
          <div className="title-and-image">
            <div className="main-title-container">
              <p className="main-blogtitle">{blog.mainTitle}</p>
            </div>
            <div className="image-box">
              <img src={blog.image} alt={blog.imageAlt} />
            </div>
          </div>
        </div>

        <div className="content-section">
          <div className="date-tag-row">
            <span className="publish-date">{blog.publishDate}</span>
            <span className="category-tag">{blog.category}</span>
          </div>
          
          <span className="category-tag2">{blog.category}</span>
          
          <p className="article-headline">{blog.headline}</p>
          <p className="excerpt">{blog.excerpt}</p>

          <div className="card-footer mt-auto">
            <span className="publish-date2">{blog.publishDate}</span>
            <div className="read-more-link">
              Read More
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                width="16"
                height="16"
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                style={{ marginLeft: '4px' }}
              >
                <path d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
